import { Component } from '@angular/core';
import { CustomRadioComponent, RadioOption } from '../../../shared-components/custom-radio/custom-radio.component';
import { TranslateService } from '../../../services/translate/translate.service';

@Component({
	selector: 'app-radios',
	templateUrl: './radios.component.html',
	styleUrls: ['./radios.component.scss'],
	standalone: false,
})
export class RadiosComponent {
	selectedStatus: string | number = '';
	selectedVertical: string | number = '';
	selectedNotification: string | number = '';
	selectedPriority: string | number = '';
	selectedAction: string | number = '';
	selectedDelete: string | number = '';
	selectedDisabled: string | number = '';
	selectedRequired: string | number = '';
	validationValid = false;
	requiredRadioRules: any[] = [];

	statusOptions: RadioOption[] = [
		{ label: 'Active', value: 'active', displayValue: 'Active' },
		{ label: 'Inactive', value: 'inactive', displayValue: 'Inactive' },
	];

	notificationOptions: RadioOption[] = [
		{ label: 'Email', value: 'email', displayValue: 'Email', icon: 'fa-solid fa-envelope' },
		{ label: 'SMS', value: 'sms', displayValue: 'SMS', icon: 'fa-solid fa-sms' },
	];

	priorityOptions: RadioOption[] = [
		{ label: 'Low Priority', value: 'low', displayValue: 'Low', icon: 'fa-solid fa-info-circle', tooltip: 'Low priority tasks' },
		{ label: 'High Priority', value: 'high', displayValue: 'High', icon: 'fa-solid fa-info-circle', tooltip: 'High priority tasks' },
	];

	actionOptions: RadioOption[] = [
		{ label: 'Proceed', value: 'proceed', displayValue: 'Proceed', icon: 'fa-solid fa-exclamation-triangle' },
		{ label: 'Cancel', value: 'cancel', displayValue: 'Cancel', icon: 'fa-solid fa-times-circle' },
	];

	deleteOptions: RadioOption[] = [
		{ label: 'Permanent Delete', value: 'permanent', displayValue: 'Permanent', icon: 'fa-solid fa-trash' },
		{ label: 'Move to Trash', value: 'trash', displayValue: 'Trash', icon: 'fa-solid fa-trash-alt' },
	];

	disabledOptions: RadioOption[] = [
		{ label: 'Option 1', value: 'option1', displayValue: 'Option 1', icon: 'fa-solid fa-ban', disabled: true },
		{ label: 'Option 2', value: 'option2', displayValue: 'Option 2', icon: 'fa-solid fa-ban', disabled: true },
	];

	requiredOptions: RadioOption[] = [
		{ label: 'Yes, I agree', value: 'agree', displayValue: 'Agree' },
		{ label: 'No, I decline', value: 'decline', displayValue: 'Decline' },
	];

	constructor(private translateService: TranslateService) {
		this.requiredRadioRules = [CustomRadioComponent.createRules(this.translateService).required('You must select an option')];
	}

	onValidationChange(validation: { isValid: boolean; errors: string[] }): void {
		this.validationValid = validation.isValid;
	}

	onRadioChange(radioName: string, value: string | number): void {
		console.log(`Custom radio changed: ${radioName} = ${value}`);

		if (radioName === 'Status') {
			this.selectedStatus = value;
		} else if (radioName === 'Vertical') {
			this.selectedVertical = value;
		} else if (radioName === 'Notification') {
			this.selectedNotification = value;
		} else if (radioName === 'Priority') {
			this.selectedPriority = value;
		} else if (radioName === 'Action') {
			this.selectedAction = value;
		} else if (radioName === 'Delete') {
			this.selectedDelete = value;
		} else if (radioName === 'Disabled') {
			this.selectedDisabled = value;
		} else if (radioName === 'Required') {
			this.selectedRequired = value;
		}
	}
}
